import type { ProductNotPurchasableMessage as ProductNotPurchasableMessageSchema } from '../../../../amplienceTypes/schemas/imported/product-not-purchasable-message-schema';
import type { Size } from '../../../../utilities/graphql/codegen';
import type { ReactElement } from 'react';

import { useMemo } from 'react';
import styled from 'styled-components';

import { usePDPDynamicContext } from '../../../../utilities/context/dynamic/PDPDynamicContext';
import { usePDPContext } from '../../../../utilities/context/static/PDPContext';
import { Typography } from '../../../shared/core/typography/Typography';

const S = {
  ProductNotPurchasableMessageWrapper: styled.div`
    margin: 1em 0 1.5em;
    padding: 0;
  `,
  ProductNotPurchasableMessage: styled(Typography)`
    text-align: left;
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.content.error};
    font-size: ${({ theme }) => theme.font.size['2']};
  `,
};

interface ProductNotPurchasableMessageProps {
  selectedSize?: Size | null;
}

export const ProductNotPurchasableMessage = ({
  onlyReasonV2,
  notOnlyReasonV2,
  selectedSize,
}: ProductNotPurchasableMessageSchema & ProductNotPurchasableMessageProps): ReactElement => {
  const {
    product: { sizeInformation },
  } = usePDPContext();
  const {
    dynamicProductData: { sizeInformation: dynamicSizeInformation },
  } = usePDPDynamicContext();

  const sizes = dynamicSizeInformation?.sizes ?? sizeInformation?.sizes;

  const notOnlyReason = useMemo(
    () => sizes?.every(size => !size?.notPurchasableDueToStock),
    [sizes]
  );

  return (
    <S.ProductNotPurchasableMessageWrapper data-testid="summary-product-not-purchasable-message">
      <S.ProductNotPurchasableMessage component="div" variant="body" data-cs-capture="">
        {notOnlyReason || (selectedSize && !selectedSize?.willBeAvailable)
          ? notOnlyReasonV2 || ''
          : onlyReasonV2 || ''}
      </S.ProductNotPurchasableMessage>
    </S.ProductNotPurchasableMessageWrapper>
  );
};
